import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { saveQuoteRequest } from '../mock/mockData';
import { toast } from 'sonner';

const PriceSection = () => {
  const [quoteForm, setQuoteForm] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    size: '',
    quantity: '',
    message: ''
  });

  const handleQuoteSubmit = (e) => {
    e.preventDefault();
    saveQuoteRequest(quoteForm);
    toast.success('Quote request submitted successfully! We will contact you soon.');
    setQuoteForm({
      name: '',
      email: '',
      phone: '',
      company: '',
      size: '',
      quantity: '',
      message: ''
    });
  };

  const handleInputChange = (e) => {
    setQuoteForm({
      ...quoteForm,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="pricing" className="py-20 bg-gradient-to-b from-white to-amber-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Pricing & <span className="text-amber-700">Quotation</span>
            </h2>
            <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Competitive prices with unmatched quality. Request a custom quote for bulk orders
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            {/* Quote Request Form */}
            <div className="bg-gradient-to-br from-amber-600 to-orange-600 rounded-2xl shadow-xl p-8 text-white">
              <div className="flex items-center mb-6">
                <Send className="mr-3" size={32} />
                <h3 className="text-2xl font-bold">Request Custom Quote</h3>
              </div>
              <p className="mb-6 text-amber-50">
                Fill out the form below and we'll get back to you with a customized quotation within 24 hours.
              </p>
              <form onSubmit={handleQuoteSubmit} className="space-y-4">
                <div>
                  <Input
                    type="text"
                    name="name"
                    placeholder="Your Name *"
                    value={quoteForm.name}
                    onChange={handleInputChange}
                    required
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email Address *"
                    value={quoteForm.email}
                    onChange={handleInputChange}
                    required
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number *"
                    value={quoteForm.phone}
                    onChange={handleInputChange}
                    required
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Input
                    type="text"
                    name="company"
                    placeholder="Company Name"
                    value={quoteForm.company}
                    onChange={handleInputChange}
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Input
                    type="text"
                    name="size"
                    placeholder="Size Required (e.g., 4 inch)"
                    value={quoteForm.size}
                    onChange={handleInputChange}
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Input
                    type="text"
                    name="quantity"
                    placeholder="Quantity"
                    value={quoteForm.quantity}
                    onChange={handleInputChange}
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <div>
                  <Textarea
                    name="message"
                    placeholder="Additional Requirements or Questions"
                    value={quoteForm.message}
                    onChange={handleInputChange}
                    rows={3}
                    className="bg-white/95 border-amber-300 text-gray-800 placeholder:text-gray-500"
                  />
                </div>
                <Button 
                  type="submit"
                  className="w-full bg-white text-amber-700 hover:bg-amber-50 font-bold text-lg py-6 rounded-lg shadow-lg hover:shadow-xl transition-all hover:scale-105"
                >
                  <Send className="mr-2" size={20} />
                  Request Quote
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceSection;
